"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    id: 'blueprint',
    name: 'Blueprint',
    background_color: '#051727',
    background_image: 'https://assets.raydiant.com/images/blueprint.jpg',
    background_image_portrait: 'https://assets.raydiant.com/images/blueprint-portrait.jpg',
    heading_font: 'https://fonts.raydiant.com/Oswald-Light.woff',
    heading_text_color: '#1d94c6',
    heading_2_font: 'https://fonts.raydiant.com/Oswald-SemiBold.woff',
    heading_2_text_color: '#4596b8',
    body_font: 'https://fonts.raydiant.com/PlayfairDisplay-Regular.woff',
    body_text_color: '#f6f6f6',
    border_color: '#b2b2b2',
};
//# sourceMappingURL=blueprint.js.map


// WEBPACK FOOTER //
// ../raydiant-kit/lib/themes/blueprint.js